// extracted by mini-css-extract-plugin
export default {"root":"simlpleReport_root__5c8jl","textWrapper":"simlpleReport_textWrapper__XAQAo","textInner":"simlpleReport_textInner__aVh2v","item":"simlpleReport_item__uzdWx"};